import React, { useRef, useEffect, useMemo } from 'react';
import { useGLTF } from "@react-three/drei";
import * as THREE from 'three';
import useGlobal from '../store';
import { disposeMaterial } from '../scripts/helpers/create.pbr.material';
import { createGlassMaterial, isGlassMeshName } from '../scripts/helpers/create.glass.material';

const Balkon = ( props ) => {

  const [ globalState ] = useGlobal();

  // resetProjectStates() обнуляет модель, пока Canvas ещё смонтирован.
  // useGLTF нельзя вызывать условно и нельзя кормить null — GLTFLoader падает в extractUrlBase.
  if ( !globalState.balkon_model ) return null;

  return <BalkonModel { ...props } />;

};

const BalkonModel = ( props ) => {

  const [ globalState, globalActions ] = useGlobal();
  const { balkon_model, balkon_position, sill_texture_image, stretchCeiling } = globalState;
  const { constructor } = globalActions;
  
  const ref = useRef();
  const GLTF = useGLTF( balkon_model );
  const scene = useMemo(() => GLTF.scene.clone(), [ GLTF?.scene ]);


  useEffect(() => { 

    if ( scene ) {

      // Upgrade unnamed Plane.* panes to real glass (once per model load)
      scene.traverse(( o ) => {

        if ( !o.isMesh ) return;

        if ( isGlassMeshName( o.name ) ) {

          if ( o.material && !o.material.userData?.isGlass ) {

            if ( o.material.userData?.isConstructorMaterial ) {

              disposeMaterial( o.material );

            }

            o.material = createGlassMaterial();
            o.castShadow = false;
            o.receiveShadow = false;
            o.renderOrder = 2;

          }

        }

      });
    
      props.refDOM.current = ({ target, texture }) => {

        scene.traverse(( o ) => {
    
          if ( o.isMesh ) {

            // Never overwrite glass panes with wall/floor textures
            if ( isGlassMeshName( o.name ) || o.material?.userData?.isGlass ) {

              return;

            }

            o.castShadow = true;
            o.receiveShadow = true;
      
            if ( 
              o.name.includes( target )
              ||
              ( target === "windowSill" && o.name.indexOf( target ) !== -1 )
              ||
              ( target === "window" && o.name.indexOf( target ) !== -1 )
            ) {
      
              if (
                o.material
                && o.material !== texture
                && o.material.userData?.isConstructorMaterial
              ) {

                disposeMaterial( o.material );

              }

              o.material = texture;
              o.material.needsUpdate = true;
              o.nameID = target;
      
            }

            const name = o.name || '';
            const needsDoubleSide = (
              name.indexOf( 'window' ) !== -1
              || name.indexOf( 'sill' ) !== -1
            );

            if ( o.material ) {

              o.material.side = needsDoubleSide ? THREE.DoubleSide : THREE.FrontSide;

            }
      
          }
      
        });
    
      }
      
      props.syncTextures(); 
  
    }
  
  }, [ balkon_model, sill_texture_image, stretchCeiling ]);
      
  return (

    !scene 
    
      ? null 
      
      : <primitive

        { ...props } 
        object = { scene }
        ref = { ref }
        dispose = { null }
        position = { balkon_position }
        castShadow 
        receiveShadow
        onClick={(e) => { 
          
          constructor.setModelRef( 'balkon', e.object.name );
          e.stopPropagation();
          
        }}

      />

  );

}

export default Balkon;
